module.exports = __webpack_public_path__ + "static/media/bonair2.a7b977cb.JPG";